import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';
import App from 'App'
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ShadowProvider } from 'ShadowContext';
import { ASSETS } from 'configuration/ConfigurazioneRotte';
import { GlobalContext } from 'GlobalContext';

const defaultCss = [
  'css/spid-sp-access-button.css'
];

const defaultJs = [

]

class FrontofficeApp extends HTMLElement {
  constructor() {
    super();
    // crea lo shadow root
    this._shadowRoot = this.attachShadow({ mode: 'closed' });
    this._root = null;
    this._modalContainer = null;
    this.reactApp = null
  }

  connectedCallback() {
     // Evita di montare più volte React nello stesso container
    if (this._root) return
    // crea un container interno al shadow root
    this._root = document.createElement('div');
    this._root.id = 'root';

    const configurazione = JSON.parse(this.getAttribute('configurazione') || "{}");

    defaultCss.forEach(href => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = ASSETS+href
      this._shadowRoot.appendChild(link)
    })   

    defaultJs.forEach(src => {
      const script = document.createElement('script')
      script.type = 'module' // se è modulo ES6
      script.src = ASSETS+src
      this._shadowRoot.appendChild(script)
    })
    
    const tagsStyleAggiuntivi = [
      ...document.querySelectorAll('style[data-base-ui]'),
      ...document.querySelectorAll('style[data-cke]'),
    ]
    tagsStyleAggiuntivi.forEach(tagStyle => {
      this._shadowRoot.appendChild(tagStyle)
    })

    this._modalContainer = document.createElement('div')
    this._shadowRoot.appendChild(this._modalContainer)
    // necassario per montare mui nello shadow invece che nell'head
    const cache = createCache({
      key: 'mui',
      container: this._modalContainer, //
    });   
    
    this._shadowRoot.appendChild(this._root);
    this.reactApp = createRoot(this._root);
    this.reactApp.render(
      <CacheProvider value={cache}>
        <ShadowProvider shadowRoot={this._modalContainer}>
          <StrictMode>
            <GlobalContext configurazione={configurazione} >
              <App />
            </GlobalContext>
          </StrictMode>
        </ShadowProvider>
      </CacheProvider>
    )
  }

  disconnectedCallback() {
   if (this._root) {
      this.reactApp.unmount();
      this._root.remove()
      this._root = null
    }
    if (this._modalContainer) {
      this._modalContainer.remove()
      this._modalContainer = null
    }
  }
}

customElements.define('frontoffice-app', FrontofficeApp);